import DiscoverPaginationGroup from './DiscoverPaginationGroup';

export default DiscoverPaginationGroup;
